import { useSheetContext } from "@/context/sheet";
import { useCreatePayment } from "@/hooks/payments";
import { CreatePayment } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-components/form";

export const Route = createFileRoute(
  "/(payments)/payments/$id/_sheet/deposit/new",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { mutateAsync } = useCreatePayment({
    onSuccess: () => {
      close(() => {
        navigate({
          to: "/payments/$id",
          params: { id },
        });
      });
    },
  });

  const create = async (payment: CreatePayment) => {
    await mutateAsync(payment);
  };

  return <Form onUpsert={create} isDeposit reservationId={id} />;
}
